module.exports = __webpack_public_path__ + "static/media/shopify.3715a1d8.svg";